var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "header_common_box media_small_hide",
          class: { bg_blue: _vm.pageName == "login" }
        },
        [
          _c("div", { staticClass: "container_box" }, [
            _c("div", { staticClass: "header_main" }, [
              _c("div", { staticClass: "flex-start" }, [
                _c(
                  "div",
                  {
                    staticClass: "logo_box",
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/")
                      }
                    }
                  },
                  [
                    _vm.pageName != "login"
                      ? _c("img", {
                          attrs: {
                            src: require("../assets/images/index_top_logo.png"),
                            alt: ""
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../assets/images/index_bot_logo.png"),
                            alt: ""
                          }
                        })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nav_box" },
                  [
                    _c(
                      "el-menu",
                      {
                        staticClass: "el-menu-demo",
                        attrs: {
                          "default-active": _vm.activeIndex,
                          "text-color": _vm.color,
                          "background-color": "transparent",
                          mode: "horizontal"
                        },
                        on: { select: _vm.routePath }
                      },
                      _vm._l(_vm.NavList, function(item, key) {
                        return _c(
                          "el-menu-item",
                          { key: key, attrs: { index: item.routerPath } },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search_box" },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "搜一搜" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getSearch()
                          }
                        },
                        model: {
                          value: _vm.searchValue,
                          callback: function($$v) {
                            _vm.searchValue = $$v
                          },
                          expression: "searchValue"
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "el-icon-search",
                          attrs: { slot: "suffix" },
                          on: {
                            click: function($event) {
                              return _vm.getSearch()
                            }
                          },
                          slot: "suffix"
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-left": "25px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.download()
                          }
                        }
                      },
                      [_vm._v("下载APP")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.token
                ? _c("div", { staticClass: "login_btn" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn_item",
                        class: { bg_white: _vm.pageName == "login" },
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/login")
                          }
                        }
                      },
                      [_vm._v("登录")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn_item",
                        class: { bg_white: _vm.pageName == "login" },
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/register")
                          }
                        }
                      },
                      [_vm._v("注册")]
                    )
                  ])
                : _c("div", { staticClass: "user_box" }, [
                    _c(
                      "div",
                      {
                        staticClass: "main",
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/member-index")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "avatar_box" }, [
                          _vm.userInfo.avatar
                            ? _c("img", {
                                attrs: { src: _vm.userInfo.avatar, alt: "" }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../assets/images/avatar.jpg"),
                                  alt: ""
                                }
                              })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "name ellipsis-multiline" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.userInfo.nickName) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pop_box", on: { click: _vm.quite } },
                      [_vm._v("退出")]
                    )
                  ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mobile_header_box media_big_hide" }, [
        _c(
          "div",
          { staticClass: "header_box" },
          [
            _c("router-link", { staticClass: "logo", attrs: { to: "/" } }, [
              _c("img", {
                attrs: {
                  src: require("../assets/images/index_top_logo.png"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn_list" }, [
              _c("div", {
                staticClass: "el-icon-search search_btn",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/search")
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "btn", on: { click: _vm.showDraw } }, [
                _c("img", {
                  attrs: { src: require("../assets/images/menu.png"), alt: "" }
                })
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticClass: "mobile_right_nav",
          attrs: {
            title: "导航",
            visible: _vm.drawer,
            size: "60%",
            "with-header": false
          },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "draw_main" },
            [
              _c(
                "el-menu",
                {
                  staticClass: "menu_box",
                  attrs: {
                    "default-active": this.$route.path,
                    "default-openeds": ["0"],
                    "unique-opened": "",
                    router: ""
                  },
                  on: {
                    open: _vm.handleOpen,
                    close: _vm.handleClose,
                    select: _vm.routeH5Path
                  }
                },
                [
                  _vm._l(_vm.NavList, function(item, key) {
                    return [
                      !item.children
                        ? _c(
                            "el-menu-item",
                            { key: key, attrs: { index: item.routerPath } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        : _c(
                            "el-submenu",
                            { key: key + "1", attrs: { index: key + "" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", [_vm._v(_vm._s(item.name))])
                              ]),
                              _vm._v(" "),
                              _vm._l(item.children, function(list, i) {
                                return _c(
                                  "el-menu-item",
                                  { key: i, attrs: { index: list.routerPath } },
                                  [_vm._v(_vm._s(list.name))]
                                )
                              })
                            ],
                            2
                          )
                    ]
                  }),
                  _vm._v(" "),
                  _vm.token
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "8" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "nav_item" }, [
                              _c("div", { staticClass: "avatar" }, [
                                _vm.userInfo.avatar
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.userInfo.avatar,
                                        alt: ""
                                      }
                                    })
                                  : _c("img", {
                                      attrs: {
                                        src: require("../assets/images/avatar.jpg"),
                                        alt: ""
                                      }
                                    })
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "name ellipsis-multiline" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.userInfo.nickName) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "/member-index/account-info" } },
                            [_vm._v("账号资料")]
                          ),
                          _vm._v(" "),
                          _vm.type == 2
                            ? _c(
                                "el-menu-item",
                                {
                                  attrs: {
                                    index: "/member-index/agent-greenhouse"
                                  }
                                },
                                [_vm._v("代理专属通道")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "/member-index/my-events" } },
                            [_vm._v("我的赛事")]
                          )
                        ],
                        2
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.download()
                        }
                      }
                    },
                    [_vm._v("下载APP")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.token
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "btn_box btn_box1",
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/login")
                          }
                        }
                      },
                      [_vm._v("登录")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn_box",
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/register")
                          }
                        }
                      },
                      [_vm._v("注册")]
                    )
                  ])
                : _c("div", [
                    _c(
                      "div",
                      { staticClass: "btn_box", on: { click: _vm.quite } },
                      [_vm._v("退出")]
                    )
                  ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d15406a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d15406a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-common.vue
// module id = null
// module chunks = 